export default __webpack_public_path__ + "static/media/poi_SESUnits_multi.eeaadfe6.svg";